import { setClassName } from '@change-corgi/core/error';

import type { UPLOAD_ERROR_MESSAGES } from '../constants';

export type UploadErrorReason = keyof typeof UPLOAD_ERROR_MESSAGES;

/**
 * Maps an Uppy error message to the corresponding UPLOAD_ERROR_MESSAGES reason.
 * Uppy surfaces restriction and upload failures as free-text messages, so we
 * pattern-match them into a stable reason the UI can translate.
 */
export function getUploadErrorReason(message: string): UploadErrorReason {
	if (message.match(/You can only upload: image/)) {
		return 'UNSUPPORTED_FILE_TYPE';
	}
	if (message.includes('exceeds maximum allowed size of')) {
		return 'IMAGE_TOO_LARGE';
	}
	if (message.match(/You can only upload \d+ file/)) {
		return 'UPLOADED_TOO_MANY_FILES';
	}
	return 'CATCH_ALL';
}

/**
 * Error thrown by the uploader when an upload fails. Carries a categorized
 * `reason` so callers can surface the actual cause rather than a generic message.
 */
export class UploadError extends Error {
	readonly reason: UploadErrorReason;

	constructor(reason: UploadErrorReason, message?: string) {
		super(message);
		this.reason = reason;
	}
}
setClassName(UploadError, 'UploadError');
